export const PERIODS_SEPARATORS = {
  month: '-M',
  halfYear: '-H',
  quarter: '-Q',
  week: '-W',
} as const;
